import React from 'react';

interface BadgeButtonProps {
  quantity: number;
  onIncrement: () => void;
  onDecrement: () => void;
}

const BadgeButton: React.FC<BadgeButtonProps> = ({
  quantity,
  onIncrement,
  onDecrement,
}) => {
  return (
    <div className="relative w-40 h-14">
      {/* Background Rectangle */}
      <div className="absolute inset-0 bg-gray-100 rounded-full" />

      {/* Content */}
      <div className="relative z-10 flex items-center justify-between h-full px-4">
        {/* Decrement Button */}
        <button
          onClick={onDecrement}
          aria-label="Decrease quantity"
          className="w-8 h-8 flex items-center justify-center text-lg text-gray-900 rounded-full hover:bg-gray-200"
        >
          -
        </button>

        {/* Quantity */}
        <span className="text-xl font-medium text-gray-900">{quantity}</span>

        {/* Increment Button */}
        <button
          onClick={onIncrement}
          aria-label="Increase quantity"
          className="w-8 h-8 flex items-center justify-center text-lg text-gray-900 rounded-full hover:bg-gray-200"
        >
          +
        </button>
      </div>
    </div>
  );
};

export default BadgeButton;
